import { useState, useCallback } from 'react';
import { useCurrentUser } from '@hooks/users';
import { useGetChatsQuery, useGetChatQuery, useCreateMessageMutation } from '@teachur/http-client';
import { useChatSocket } from './useChatSocket';
import { toast } from 'react-toastify';

export const useChatPage = () => {
  const { data: user } = useCurrentUser();
  const { data: chatsResponse } = useGetChatsQuery({ limit: 50, offset: 0 });
  const chats = chatsResponse?.data || [];
  const [selectedChatId, setSelectedChatId] = useState<number | undefined>(undefined);
  const [mobileShowConversation, setMobileShowConversation] = useState(false);

  useChatSocket(selectedChatId);

  const unreadChatIds = new Set<number>();

  const currentUserId = user?.id ?? 0;

  const { data: selectedChat } = useGetChatQuery(selectedChatId ?? 0);

  const createMessage = useCreateMessageMutation(selectedChatId ?? 0, {
    onError: () => toast.error('Failed to send message.'),
  });

  const handleSelectChat = useCallback((chatId: number) => {
    setSelectedChatId(chatId);
    setMobileShowConversation(true);
  }, []);

  const handleBack = useCallback(() => {
    setMobileShowConversation(false);
  }, []);

  const handleSendMessage = useCallback(
    (text: string) => {
      if (!selectedChatId || !currentUserId || !selectedChat) return;
      const recipient = selectedChat.users?.find((u) => u.id !== currentUserId);
      if (!recipient) return;
      createMessage.mutate({ text, sendChatUserId: recipient.id });
    },
    [selectedChatId, currentUserId, selectedChat, createMessage]
  );

  return {
    chats,
    currentUserId,
    selectedChat,
    selectedChatId,
    unreadChatIds,
    mobileShowConversation,
    handleSelectChat,
    handleBack,
    handleSendMessage,
  };
};
